import {
  ListItem,
  ListItemProps,
  Text
} from "@chakra-ui/react";
import * as React from "react";
import {CheckIcon} from "./check-icon";

export const PricingDetail = (props: ListItemProps & {iconColor: string;}) => {
  const {children,iconColor,...rest} = props;
  return (
    <ListItem
      display="flex"
      alignItems="flex-start"
      fontWeight="medium"
      maxW="260px"
      {...rest}
    >
      <CheckIcon marginEnd="3" mt="1" color={iconColor} />
      <Text as="span" display="inline-block">
        {children}
      </Text>
    </ListItem>
  );
};
